import React, { useState } from 'react';
import { VscChromeClose } from 'react-icons/vsc';

export const TagInput = ({ tags, setTags }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter' || !inputValue.trim()) return;
    e.preventDefault();
    const newTag = inputValue.trim();
    if (!tags.includes(newTag)) {
      setTags([...tags, newTag]);
    }
    setInputValue('');
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  return (
    <div>
      <div className="bg-2 border-line flex flex-wrap gap-2 rounded-lg border p-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className="flex items-center gap-2 rounded-full bg-[#5652CF]/20 px-3 py-1 text-sm font-medium text-blue-300"
          >
            {tag}
            <button
              onClick={() => removeTag(tag)}
              className="text-blue-200 hover:text-white"
            >
              <VscChromeClose />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type header and press Enter..."
          className="text-p-text placeholder-s-text flex-grow bg-transparent p-1 outline-none"
        />
      </div>
    </div>
  );
};
